import isEmail from 'validator/lib/isEmail';

export interface DataPromotion {
    id: string;
    title: string;
    description: string;
    code: string;
    total: string;
    start_at: any;
    end_at: string;
    promo_picture: string;
    doc_name: string;
    type_promotion: string;
    amount: number;
    updated_by: string;
    created_by: string;
    updated_at: string;
    created_at: string;
}

export const validateEmail = (valor: string): boolean => {
    const [beforeAt, afterAt] = valor.split('@');
    const blacklist = [
        'gmail.mx',
        'hotmail.mx',
        'aol',
        'hotmail.com.mx',
        'gmail.com.mx',
        'live.com.mx',
        'gmail.co',
        'ensamble.dev',
        'outloot.com',
        'yahoo.com.sg',
        '@',
        'yopmail.com',
    ];

    if (beforeAt.length <= 2) {
        return false
    }
    if (blacklist.includes(afterAt)) {
        return false
    }
    if (valor === '') {
        return false
    } else if (!isEmail(valor)) {
        return false
    } else {
        return true;
    }
};

export const calculateAge = (birthday: any): number => {
    const fechaActual = new Date();
    const anoActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    const diaActual = fechaActual.getDate();

    const anoNacimiento = parseInt(String(birthday).substring(0, 4));
    const mesNacimiento = parseInt(String(birthday).substring(5, 7));
    const diaNacimiento = parseInt(String(birthday).substring(8, 10));

    let edad = anoActual - anoNacimiento;
    if (mesActual < mesNacimiento) {
        edad--;
    } else if (mesActual === mesNacimiento) {
        if (diaActual < diaNacimiento) {
            edad--;
        }
    }
    return edad;
};

export const allEqual = (arr: string[]) => arr.every((val) => val === arr[0]);

export const isThereFourConsecutiveNumber = (numbers: string) => {
    if (/(^|(.)(?!\2))(\d)\3{4,}(?!\3)/.test(numbers)) {
        return true;
    }
    return false;
};

export const typePromotion = (infoPromo: DataPromotion) => {
    switch (infoPromo.type_promotion) {
        case 'tarjeta_digital':
            return infoPromo.amount;
            break;
        case 'membresias':
            return infoPromo.amount;
            break;
        case 'descuento':
            return infoPromo.amount;
            break;
        case 'premio_fisico':
            return infoPromo.amount;
            break;
    }
};

export const RemainTime = (endDateTime: string) => {
    let now: any = new Date();
    let end: any = new Date(endDateTime);
    let remainTime = (end - now + 1000) / 1000;
    return {
        remainTime,
    };
};

export const validateCouponDateTime = (endDateTime = '', acceptCoupon = "") => {
    let isValidate: boolean = false;
    if (endDateTime !== '' && acceptCoupon === '1') {
        let t = RemainTime(endDateTime);
        if (t.remainTime <= 1) {
            isValidate = false;
        } else if (acceptCoupon === '1') {
            isValidate = true;
        }
    }

    return isValidate;
};

export const NameSubstring = (name: string = '') => {
    let new_name = '';
    if (name.length > 8) {
        new_name = name.substring(0, 9) + '...';
    } else {
        new_name = name;
    }
    return new_name;
};

export const isAscendingDescending = (phoneNumber: string): boolean => {
    // Verificar que no haya una secuencia completa de números consecutivos ascendentes o descendentes
    for (let i = 0; i <= phoneNumber.length - 5; i++) {
        const sequence = phoneNumber.slice(i, i + 5);
        if (/12345|54321|67890|98765/.test(sequence)) {
            return true;
        }
    }
    // Si pasa todas las validaciones, regresamos false
    return false;
};

export const randomNumber = () => {
    return Math.ceil(Math.random()*10)
}
